<div class="form-control w-full space-y-2">
  @if (label) {
    <label class="label font-medium text-sm">
      <span class="label-text">{{ label }}</span>
    </label>
  }

  @if (isLoading()) {
    <div class="flex items-center gap-2 p-2 text-sm text-gray-500">
      <span class="loading loading-spinner loading-sm"></span>
      Chargement des EPI...
    </div>
  } @else {
    <div class="space-y-3">
      @for (row of rows(); track $index; let i = $index) {
        <div class="flex flex-wrap sm:flex-nowrap items-center gap-2 bg-base-200 p-3 rounded-lg border border-base-300">

          <!-- Select EPI -->
          <div class="form-control flex-1 min-w-50">
            <div class="flex flex-row gap-2">
              <select
                class="select select-bordered select-sm w-full"
                [(ngModel)]="row.selectedEpiId"
                (change)="onRowChange()"
                [disabled]="disabled()"
              >
                <option value="" disabled>-- Sélectionner un EPI --</option>
                @for (epi of epiList(); track epi._id) {
                  <option [value]="epi._id">
                    {{ epi.name }} ({{ epi.price }} €)
                  </option>
                }
              </select>

            @if (rows().length > 1) {
              <button
                type="button"
                class="btn btn-outline btn-error btn-sm btn-square"
                (click)="removeRow(i)"
                [disabled]="disabled()"
                title="Supprimer cet EPI"
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24">
                  <path d="M0 0h24v24H0z" fill="none" />
                  <path fill="currentColor" d="M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12z" />
                </svg>
              </button>
            }
            </div>
          </div>

          <!-- Input Taille -->
          <div class="form-control w-full sm:w-32">
            <input
              type="text"
              placeholder="Taille (ex: XL, 42)"
              class="input input-bordered input-sm w-full"
              [(ngModel)]="row.size"
              (input)="onRowChange()"
              [disabled]="disabled()"
            />
          </div>
        </div>
      }

      <!-- Bouton Ajouter -->
      <button
        type="button"
        class="btn btn-outline btn-primary btn-sm mt-2"
        (click)="addRow()"
        [disabled]="disabled()"
      >
        + Ajouter un EPI
      </button>
    </div>
  }
</div>
